import * as api from '@/services/ApiService'
import {
    CancelSubscriptionRequest,
    CreateSubscriptionRequest,
    EditSubscriptionQuantityRequest,
    QuerySubscriptionsRequest,
    QuerySubscriptionsResponse,
    Subscription
} from '@/core/ApiTypes'
import { PromiseCache } from '@/core/PromiseCache'
import { ItemEvent } from '@/model/EventTypes'
import { Observable, Subject } from 'rxjs'

export class SubscriptionsManager {
    private readonly cache = new PromiseCache<string, Subscription>()
    private readonly eventSubject = new Subject<ItemEvent<Subscription>>()

    get eventStream(): Observable<ItemEvent<Subscription>> {
        return this.eventSubject
    }

    async getSubscription(stripeSubscriptionId: string): Promise<Subscription> {
        return this.cache.get(stripeSubscriptionId, () => api.getSubscription(stripeSubscriptionId))
    }

    async querySubscriptions(request: QuerySubscriptionsRequest): Promise<QuerySubscriptionsResponse> {
        const response = await api.querySubscriptions(request)

        if (response.subscriptions) {
            for (const subscription of response.subscriptions)
                this.cache.set(subscription.id, subscription)
        }

        return response
    }

    async createSubscription(request: CreateSubscriptionRequest): Promise<Subscription> {
        const subscription = await api.createSubscription(request)
        if (subscription)
            this.cache.set(subscription.id, subscription)

        // publish event
        this.eventSubject.next(ItemEvent.added(subscription))

        return subscription
    }

    async editSubscriptionQuantity(request: EditSubscriptionQuantityRequest): Promise<Subscription> {
        const subscription = await api.editSubscriptionQuantity(request)
        if (subscription)
            this.cache.set(subscription.id, subscription)

        // publish event
        this.eventSubject.next(ItemEvent.changed(subscription))

        return subscription
    }

    async cancelSubscription(request: CancelSubscriptionRequest): Promise<Subscription> {
        const subscription = await api.cancelSubscription(request)
        if (subscription)
            this.cache.set(subscription.id, subscription)

        // publish event
        this.eventSubject.next(ItemEvent.changed(subscription))

        return subscription
    }
}